import { render, staticRenderFns } from "./PreviewOtherUserTemplateModal.vue?vue&type=template&id=ebe01252&scoped=true&lang=pug"
import script from "./PreviewOtherUserTemplateModal.vue?vue&type=script&lang=ts"
export * from "./PreviewOtherUserTemplateModal.vue?vue&type=script&lang=ts"
import style0 from "./PreviewOtherUserTemplateModal.vue?vue&type=style&index=0&id=ebe01252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe01252",
  null
  
)

export default component.exports